export enum EmotionalSupport {
  LikesEarRubs = 'LikesEarRubs',
  LikesFaceKisses = 'LikesFaceKisses',
  LikesNameSaid = 'LikesNameSaid',
  LikesNoseToNoseContact = 'LikesNoseToNoseContact',
  NeedsPersonsAtTheHeadToConsole = 'NeedsPersonsAtTheHeadToConsole',
}
